import { AjaxService, internalMessageBus, Cookies, EventsManager } from "../../externals";
import { SeamlessRequestService } from "../RequestService";
import { TokenProcessingGateway, TokenHandler, RequestGateway, TokenStream, LogoutSubscription, TokenLoginSubscription, CookiesStorage, TokenReader, RenewErrorHandler, TokenLoginGateway } from "../../common";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { PlatformJwtManager } from "../../PlatformJwtManager";
export const seamlessAuthContextFactory = (config) => {
    if (!config.operatorAuthTokenId) {
        throw new Error("Invalid operatorAuthTokenId");
    }
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies);
    const service = new SeamlessRequestService(config.apiUrl, config.operatorAuthTokenId, new AjaxService(), config.pageMethods, makeTokenRequest);
    const gateway = getGateway(config, service, tokenStorage, tokenReader);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.player, tokenReader, gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, service, tokenReader, config)
    };
};
const getGateway = (config, service, storage, tokenReader) => {
    const tokenHandler = new TokenHandler(storage, internalMessageBus);
    const errorHandler = new RenewErrorHandler(config.player, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    return new RequestGateway(service, tokenProcessingGateway, storage, tokenReader, delay);
};
const getSubscriptions = (gateway, service, tokenReader, config) => [
    new LogoutSubscription(config.player, gateway, tokenReader),
    new TokenLoginSubscription(config.player, new TokenLoginGateway(config.player, gateway, tokenReader, service, legacySeamlessTokenLogin))
];
export const legacySeamlessTokenLogin = (player) => player.loadUser();
//# sourceMappingURL=SeamlessAuthContextFactory.js.map